import { render } from "./ComponentTable.vue?vue&type=template&id=09c2a237&ts=true"
import script from "./ComponentTable.vue?vue&type=script&lang=ts"
export * from "./ComponentTable.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__